import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApplicationSettingResult, EditApplicationSettingInput, GetApplicationSettingsInput, Result, ResultList } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class ApplicationSettingService {

  constructor(private httpClient: HttpClient) { }

  public editApplicationSetting(applicationSettingInput: EditApplicationSettingInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'ApplicationSetting/EditApplicationSetting', applicationSettingInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getApplicationSetting(getApplicationSettingsInput: GetApplicationSettingsInput): Promise<ResultList<ApplicationSettingResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'ApplicationSetting/GetApplicationSetting', getApplicationSettingsInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<ApplicationSettingResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<ApplicationSettingResult>(), result.error));
  }

  public  getApplicationSettings(): Promise<ResultList<ApplicationSettingResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'ApplicationSetting/GetApplicationSettings', Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<ApplicationSettingResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<ApplicationSettingResult>(), result.error));
  }
  public  getApplicationSettingsHome(): Promise<ResultList<ApplicationSettingResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'ApplicationSetting/GetApplicationSettings', Utility.options('token'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<ApplicationSettingResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<ApplicationSettingResult>(), result.error));
  }
}
